// Vuex CallbackMessages module actions
import { API } from '@/config';

import {
  FILL_DETAILS,
} from './mutations-types';

export default {
  async get({ commit }, sessionId) {
    try {
      commit(FILL_DETAILS, { details: null });
      const details = (await API.get(`/callbackMessages?session_id=${sessionId}`)).data.data;
      commit(FILL_DETAILS, { details });
    } catch (err) {
      console.log(err);
    }
  },
};
